import { CrossStorageClient } from 'cross-storage';

export const removeAlert = () => {
	const alerts = document.querySelectorAll('.alert');
	if (!alerts) {
		return;
	}
	alerts.forEach((el) => {
		el.innerHTML = '';
		el.className = 'alert';
	});
	return alerts;
};

export const addAlert = function (msg, type = 'success') {
	removeAlert();
	const alert = document.querySelector('.alert');

	alert.innerHTML = msg;
	alert.classList.add(type, 'in');
};

export const getQueryStringParams = (param) => {
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});

	if (!param || !param.length) {
		return params;
	}

	return params[param];
};

export const getLoggedInUser = function () {
	const data = {};

	const hubUrl = `${GLOBALS.uris.app}/hub`;

	const storage = new CrossStorageClient(hubUrl);

	return storage
		.onConnect()
		.then(() => {
			return storage.get(
				'access_token',
				'refresh_token',
				'user',
				'auth_token_exp'
			);
		})
		.then((res) => {
			try {
				res = res.map(JSON.parse);
			} catch (err) {
				return err;
			}

			if (res && res.length) {
				if (res[0] && res[0].length) {
					data.access_token = res[0];
				}

				if (res[1] && res[1].length) {
					data.refresh_token = res[1];
				}

				if (res[2] && res[2]._id) {
					data.user = res[2];
				}

				if (res[3] && res[3].length) {
					data.auth_token_exp = res[3];
				}

				return data;
			}
		})
		.catch((err) => {
			if (typeof Sentry !== 'undefined' && Sentry !== null) {
				Sentry.captureException(err);
			}

			return err;
		});
};
